export function scrollToIdRef(
  elementId: string,
  delay = 0,
  isId = true,
  scrollPosition: 'center' | 'end' | 'nearest' | 'start' = 'start'
): void {
  if (!window || !document) {
    console.warn(`scrollToIdRef was called on the server. This operation is not supported in SSR.`);
    return;
  }

  if (delay) {
    setTimeout(() => {
      const element = isId ? document.getElementById(elementId) : document.querySelector(elementId);
      element && element.scrollIntoView({ behavior: 'smooth', block: scrollPosition, inline: 'nearest' });
    }, delay);
    return;
  }

  const element = isId ? document.getElementById(elementId) : document.querySelector(elementId);
  if (!element) {
    console.warn(`There is no element on the page with id ${elementId}`);
    return;
  }
  element.scrollIntoView({ behavior: 'smooth', block: scrollPosition, inline: 'nearest' });
}
